<template>
  <div class="picker">
    <VueDatePicker
      v-bind="$attrs"
      id="datePicker"
      ref="datepicker"
      v-model="date"
      class="picker"
      :format="format"
      locale="ru-RU"
      :space-confirm="true"
      auto-apply
      no-today
      :ui="uiOptions"
      :enable-time-picker="false"
      :six-weeks="true"
      position="center"
    >
      <template #input-icon>
        <SvgIcon icon="calendar" class="picker__icon" />
      </template>
    </VueDatePicker>
    <span v-if="errorText" class="date__error">
      <div class="date__error-list">
        <span v-for="(error, index) in errorText" :key="index">{{
          error
        }}</span>
      </div>
    </span>
  </div>
</template>

<script lang="ts" src="./CalendarInput.ts"></script>

<style lang="scss" src="./CalendarInput.scss"></style>
